import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "payment-form"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { id: "payment-element" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner hidden",
  id: "spinner"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { id: "button-text" }, "Pay now", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "message is-danger" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "message-header" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Error")
], -1)
const _hoisted_10 = { class: "message-body" }

export function render(_ctx: any,_cache: any) {
  return (!_ctx.postError)
    ? (_openBlock(), _createElementBlock("form", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", {
          class: "button mt-3",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.pay && _ctx.pay(...args)))
        }, _hoisted_5),
        (_ctx.message != '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.message), 1))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
        _createElementVNode("article", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.postError), 1)
        ])
      ]))
}